import { Component, OnInit, ElementRef, ViewChild, HostListener, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import * as models from '../../../models';
import * as services from '../../../services';
import { Subscription } from 'rxjs';
import { DateFilterOption, DateFilterOptionEnum } from '../../../models/enumerations';

@Component({
    selector: 'app-chart-daterange-filter',
    templateUrl: './chart-daterange-filter.component.html',
    styleUrls: ['./chart-daterange-filter.component.scss'],
    standalone: false
})
export class ChartDaterangeFilterComponent implements OnInit {

  @ViewChild('dropdownButton') dropdownButton: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;

  selectedChartRange: models.DateRanger;
  showCustomRangeInput: boolean = false;
  companySub: Subscription;

  @Input() filterForEventVolumeChart: boolean;
  @Input() showYearly: boolean = true;
  @Input() showAllTime: boolean = true;
  @Input() showCustom: boolean = true;
  @Output() selectedChartDateRangeChange = new EventEmitter();
  set selectedChartDateRange(val: models.DateRanger) {
    if(val && val != null){
      this.selectedChartRange = val;  
      this.selectedChartDateRangeChange.emit(this.selectedChartRange);
    }
  }

  get selectedChartDateRange() {
    return this.selectedChartRange;
  }

  selectedOption: string;
  isDropdownOpen: boolean = false;

  constructor(
    private helperService: services.HelperService
  ) { }

  ngOnInit(): void {
  }

  setDefaultDateRange() { // default set to last month
    if (this.filterForEventVolumeChart) {
      this.selectedOption = 'week';
      this.selectedChartDateRange = {
        rangeType: 'week',
        datesInRange: this.helperService.computeDatesRange("week"),
        defaultViewSetTo: this.helperService.getDefaultInterval("week")
      }
    } else {
      this.selectedOption = DateFilterOptionEnum.LastMonth;
      this.selectedChartDateRange = {
        rangeType: DateFilterOptionEnum.LastMonth,
        datesInRange: this.helperService.computeDatesRange(DateFilterOptionEnum.LastMonth),
        defaultViewSetTo: this.helperService.getDefaultInterval(DateFilterOptionEnum.LastMonth)
      }
    }
  }

  ngAfterViewInit(): void {
    let companyId = this.helperService.currentCompanyId;
    if (companyId) {
      this.setDefaultDateRange();
    }
    this.companySub = this.helperService.getCurrentCompany().subscribe(data => {
      this.setDefaultDateRange();
    })
  }

  onCustomDateRangeChange(startDate: string, endDate: string): void {
    this.setCustomDateRange(startDate, endDate);
  }

  setCustomDateRange(startDate: string, endDate: string) {
    const dates = this.helperService.computeDatesRange(DateFilterOptionEnum.Custom, startDate, endDate);
    const defaultView = this.helperService.getDefaultInterval(DateFilterOptionEnum.Custom);
    this.selectedChartDateRange = {
      rangeType: DateFilterOptionEnum.Custom,
      datesInRange: dates,
      defaultViewSetTo: defaultView
    }
    this.isDropdownOpen = false;
  }

  optionChange(option: any) {
    if (option.value !== DateFilterOptionEnum.Custom) {
      this.isDropdownOpen = false;
      this.selectedChartDateRange = {
        rangeType: option.value,
        datesInRange: this.helperService.computeDatesRange(option.value),
        defaultViewSetTo: this.helperService.getDefaultInterval(option.value)
      };
      this.showCustomRangeInput = false;
      this.isDropdownOpen = false;
    } else {
      this.showCustomRangeInput = true;
    }
  }

  ngOnDestroy(): void {
    if (this.companySub) {
      this.companySub.unsubscribe();
    }
  }
}
